var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "AccountsDailyFlow",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c(
            "VueSlickgrid",
            {
              ref: "grid",
              staticClass: "page--grid",
              attrs: {
                name: "accountsDailyFlow",
                headerTitle: _vm._f("pgettext")(
                  "Daily Flow",
                  "AccountsDailyFlowView"
                ),
                items: _vm.getItems,
                "checkbox-row-selection": "",
                "export-to-csv": "",
                exportToCsvFilename: _vm._f("pgettext")(
                  "accounts-daily-flow",
                  "ExportFilename"
                ),
                "footer-totals": "",
                "no-column-reorder": "",
                columnDefaults: _vm.b_2248226175642056_columnDefaults,
                columns: _vm.b_2248226175642056_columns
              },
              on: {
                selectedRowsChanged: function($event) {
                  return _vm.evh_2248226175642056_selectedRowsChanged(
                    $event,
                    {}
                  )
                },
                command: function($event) {
                  return _vm.evh_2248226175642056_command($event, {})
                }
              }
            },
            [
              _c(
                "DIV",
                {
                  staticClass: "flex-grow-1 d-flex",
                  attrs: { slot: "toolbar" },
                  slot: "toolbar"
                },
                [
                  _c("UcAccountSelector", {
                    staticClass: "mr-2",
                    model: {
                      value: _vm.parameters.account,
                      callback: function($$v) {
                        _vm.$set(_vm.parameters, "account", $$v)
                      },
                      expression: "parameters.account"
                    }
                  }),
                  _vm._v(" "),
                  _c("DateRangeSelector", {
                    staticClass: "mr-2",
                    attrs: {
                      name: "paymentFilters",
                      from: _vm.parameters.date_from,
                      to: _vm.parameters.date_to
                    },
                    on: {
                      changed: function($event) {
                        return _vm.evh_8320016629450276_changed($event, {})
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("BtnLoad", {
                    staticClass: "mr-2",
                    attrs: { action: _vm.actions.load },
                    on: {
                      click: function($event) {
                        return _vm.evh_6705964765214521_click($event, {})
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("PageHelp", {
                    attrs: { path: "/finance/accounts-daily-flow.html" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }